//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommFileUpload from "@/pccomponents/CommFileUpload";
import * as axios from "@/store/http";
import * as auth from "@/utils/auth";
export default {
  extends: CommFileUpload,
  name: "openFileUplaod",
  props: {
    // 弹窗按钮名称
    btnName: {
      type: String,
      default: "Upload Attachment"
    },
    uploadTitle:{
      type: String,
      default: ""
    },
    fileForm: {
      type: Object,
      default: () => ({})
    },
    keyval:{
       type: Number,
       default: 0
    },
    uuid:{
      type:String,
      default:""
    },
    // 回调函数
    callbackFun:{
      type:Function,
      default:null
    },
    checkUploadkFun:{
       type:Function,
       default:null
    },
    matchItem:{
       type:String,
       default:""
    },
    editItem:{
          type:String,
          default:""
    },
    ifshowtip:{//未保存时是否展示文字提示信息
      type:Boolean,
      default:true
    },
     //是否兼容不用登陆访问
    nosession:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      titleName:this.$t('contract.btnUploadFile'),
      getdoctype : "api/api/portalFile/getDocuTypeInfo"
    };
  },
  methods: {
    initFileConfig(){
      //初始化文件配置
      let url = this.getdoctype;
      let params = {
        record: {
          btype: this.fileForm.btype,
          docutypeid:this.fileForm.docutypeid,
        }
      };
      axios.post(url, params).then(res => {
        if(res.data.code=="1"){
          let docuinfo=res.data.data.record.docuinfo;
          if(docuinfo!=undefined){
            this.tagName=docuinfo.tagname;
            this.tabName=docuinfo.tabname;
            this.limitNum=docuinfo.limitnum;
            this.acceptType=docuinfo.filetype;
            this.docuTypeId=docuinfo.docutypeid;
            this.maxSize=docuinfo.maxsize;
            this.btype=docuinfo.btype;
            this.chunkSize=docuinfo.chunksize;
            this.ifChunkSize=docuinfo.ifchunksize;
            if(this.limitNum>1||this.limitNum==undefined||this.limitNum==""){
              this.showmultiple=true;
            }
          }
        }
      });
    },
    handleDialogClose(){//点击X时关闭事件
       if(this.showFileList.length==0){
        this.dialogVisible = false;
       }
    },
    submitUpdateData(){
       if(this.showFileList.length==0){
          this.dialogVisible = false;
          return;
       }
       if(!this.checkFileUploadSuccess()){
         this.$message.warning(this.$t('contractcheck.checkUploadSuccess'));
         return;
       }
       if(this.callbackFun){
           this.dialogVisible = false;
            //通过回调函数，回传附件ID
            this.callbackFun();
        }
    },
    checkFileUploadSuccess(){//验证附件是否上传成功
      let flag=true;
      for(let i=0;i<this.showFileList.length;i++){
        let status=this.showFileList[i].status;
        if(status!="success"){
          flag=false;
          break;
        }
      }
      return flag;
    },
    openModel() {
        this.setDialogPos();
    },
   noOpenUpload(){
     
   }
  },
  watch: {},
  computed:{
     readonly:function(){
          if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
            //返回true,设为只读
            return true;
          }else{
            return false;
          }
    },
    nokey: function(){
         let flag=true;
         let key=this.fileForm.keyval;
         if(this.keyval==""||this.keyval==undefined||this.keyval==0){
           flag=false;
         }
         if(key!=""&&key!=undefined&&key!=0){
           flag=true;
         }
         if(this.uuid != ""){
           flag = true;
         }
         return flag;
    },
  },
  created(){
    if(this.nosession == true){
        this.getdoctype = "api/api/portalFile/getDocuTypeInfo";
        this.doUpload = "api/api/portalFile/upload";
        this.doUploadChunk = "api/api/portalFile/uploadChunk";
        this.removeUrl = "api/api/portalFile/delefilebyId";
        this.downloadUrl ="api/api/portalFile/download";
        this.uploadMergeUrl = "/api/portalFile/uploadMergeFile";//合并URL
    }
    this.initFileConfig();
  }
};



// WEBPACK FOOTER //
// ./src/pccomponents/OpenFileUpload2.vue